import _regeneratorRuntime from "/home/joey/projects/aivitar/talk-to-ai/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "/home/joey/projects/aivitar/talk-to-ai/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/web.timers.js";
import { defineComponent } from "vue";
import ImageCarousel from './ImageCarousel.vue';
export default defineComponent({
  name: "LocationPermissionsNeeded",
  components: {
    ImageCarousel: ImageCarousel
  },
  setup: function setup() {
    return {};
  },
  mounted: function mounted() {
    return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }))();
  },
  watch: {
    "$store.state.permission_camera": "handleCameraPermissionsChange"
    // "$store.state.queuedCloudTTSSentences": "processCloudTTSPayloads",
  },
  props: {},
  data: function data() {
    return {
      rating: 0,
      deniedPermissions: false,
      permissionGranted: false,
      showReviewButton: false,
      feedback: "",
      dualSubmission: false,
      handleLowerScores: false,
      shareFeedbackText: "Share Feedback With Us",
      lowerScoreSentence: "",
      success: false,
      deniedPermissionsWalkthoughAndroid: [{
        topTitle: 'To Use This Feature, You\'ll need to Enable Camera Permissions ',
        topSummary: 'You previously denied camera permissions. So, now you must enable them in your system settings.... but dont worry, we will show you how.',
        image: 'assets/web/carousels/camera_permissions/camera.png',
        description: 'Swipe left to see how to enable camera permissions'
        // description: 'Swipe Left To See How',
      }, {
        image: 'assets/web/carousels/location_permissions/android/step1.png',
        header: 'Step 1: Find The App',
        description: 'Either look for "AIVitar" app icon in your apps list or...',
        imageStyles: {
          height: "55vh",
          width: "auto",
          "max-height": "80%",
          "object-fit": "cover"
        },
        showNextButton: true
      }, {
        image: 'assets/web/carousels/location_permissions/android/step1b.png',
        header: 'Step 1: Find The App',
        description: 'Or you might be able to find it on the home screen',
        imageStyles: {
          height: "55vh",
          width: "auto",
          "object-fit": "cover"
        }
      }, {
        image: 'assets/web/carousels/location_permissions/android/step2.png',
        header: 'Step 2: Open App Settings',
        description: 'Press and hold on the app icon. Then, click the "i" icon with the circle around it to open the settings',
        imageStyles: {
          height: "35vh",
          width: "auto",
          "object-fit": "cover"
        }
      }, {
        image: 'assets/web/carousels/location_permissions/android/step3.png',
        header: 'Step 3: Open Permissions Menu',
        description: 'Next, click on "Permissions", then "Camera"',
        imageStyles: {
          height: "55vh",
          width: "auto",
          "object-fit": "cover"
        }
      }, {
        image: 'assets/web/carousels/location_permissions/android/step4.png',
        header: 'Step 4: Change Camera Permissions',
        description: 'Now, click "Allow only while using the app"',
        imageStyles: {
          height: "35vh",
          width: "auto",
          "object-fit": "cover"
        }
      }, {
        header: 'All Done!',
        description: 'Close the app and reopen it now to use the camera-based features!',
        imageStyles: {
          height: "35vh",
          width: "auto",
          "object-fit": "cover"
        }
      }

      // ... more items
      ]
      // data
    };
  },
  methods: {
    handleCameraPermissionsChange: function handleCameraPermissionsChange() {
      var _this = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              if (!(_this.$store.state.permission_camera === true || _this.$store.state.permission_camera === "true")) {
                _context2.next = 7;
                break;
              }
              _this.permissionGranted = true;
              if (!_this.$store.state.cameraPermissionsSender) {
                _context2.next = 5;
                break;
              }
              _context2.next = 5;
              return _this.$store.dispatch('checkFeatureEnabled', _this.$store.state.cameraPermissionsSender);
            case 5:
              _context2.next = 8;
              break;
            case 7:
              if (_this.$store.state.permission_location === "denied") {
                _this.permissionGranted = false;
              } else {
                _this.permissionGranted = false;
              }
            case 8:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }))();
    },
    closeModal: function closeModal() {
      this.$store.commit('updateShowCameraPermissionScreen', false);
    },
    handleRating: function handleRating(n) {
      var _this2 = this;
      this.rating = n;
      setTimeout(function () {
        if (n > 4) {
          if (_this2.handleLowerScores) {
            _this2.lowerScoreSentence = "Sweet! We love to hear that! Please leave a review on the app store!";
            _this2.shareFeedbackText = "Share Feedback";
            _this2.dualSubmission = true;
            _this2.showReviewButton = false;
          } else {
            _this2.showReviewButton = true;
          }
        } else {
          _this2.showReviewButton = false;
        }
        if (n <= 4) {
          _this2.handleLowerScores = true;
          if (n <= 2) {
            _this2.lowerScoreSentence = "Bummer! What can we do to fix this?!";
          }
          if (n > 2 && n < 4) {
            _this2.lowerScoreSentence = "Not a perfect score. We can do better! What should we work on?";
          }
          if (n === 4) {
            _this2.lowerScoreSentence = "Dang! Almost five stars! What do we need to improve to get your five stars?";
          }
        }
      }, 1100);
    }
  }
});